import { FC } from 'react'
import { Controller } from 'react-hook-form'

import SelectField from '@/components/select-field'
import { Input } from '@/components/ui/input'
import FormGroup from '@/core/components/FormGroup'
import { ApplePayKeys } from './ApplePayKeys'
import { CheckboxGroupField } from './CheckboxGroupField'
import {
  COUNTRY_CODE_OPTIONS,
  MERCHANT_CAPABILITIES,
  SUPPORTED_NETWORKS,
} from './constants'
import { PayConfigFieldsProps } from './types'

export const ApplePayFields: FC<PayConfigFieldsProps> = ({
  namePrefix,
  control,
  register,
  setValue,
  configErrors,
}) => {
  return (
    <div className="space-y-4 p-4 border border-monochrome-120 rounded-2xl">
      <h4 className="text-sm font-medium text-monochrome-1">
        Apple Pay Configuration
      </h4>

      <div className="flex gap-4">
        <Controller
          name={`${namePrefix}.countryCode`}
          control={control}
          render={({ field }) => (
            <FormGroup
              label="Country Code"
              error={configErrors?.countryCode?.message}
              className="flex-1"
            >
              <SelectField
                outline
                triggerClassName="h-[44px] rounded-2xl"
                placeholder="Select Country"
                options={COUNTRY_CODE_OPTIONS}
                value={field.value}
                onValueChange={field.onChange}
              />
            </FormGroup>
          )}
        />
      </div>

      <div className="flex gap-4">
        <FormGroup
          label="Merchant Identifier"
          error={configErrors?.merchantIdentifier?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.merchantIdentifier?.message}
            {...register(`${namePrefix}.merchantIdentifier`)}
            placeholder="Merchant Identifier"
          />
        </FormGroup>
        <FormGroup
          label="Display Name"
          error={configErrors?.displayName?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.displayName?.message}
            {...register(`${namePrefix}.displayName`)}
            placeholder="Display Name"
          />
        </FormGroup>
      </div>

      <div className="flex gap-4">
        <FormGroup
          label="Stripe Publishable Key"
          error={configErrors?.stripePublishableKey?.message}
          className="flex-1"
        >
          <Input
            isInvalid={!!configErrors?.stripePublishableKey?.message}
            {...register(`${namePrefix}.stripePublishableKey`)}
            placeholder="Stripe Publishable Key"
          />
        </FormGroup>
      </div>

      <CheckboxGroupField
        name={`${namePrefix}.supportedNetworks`}
        control={control}
        label="Supported Networks"
        options={SUPPORTED_NETWORKS}
      />
      <CheckboxGroupField
        name={`${namePrefix}.merchantCapabilities`}
        control={control}
        label="Merchant Capabilities"
        options={MERCHANT_CAPABILITIES}
      />

      <ApplePayKeys
        namePrefix={namePrefix}
        control={control}
        setValue={setValue}
      />
    </div>
  )
}
